export type CountdownParts = {
    weeks: number;
    days: number;
    hours: number;
    minutes: number;
};

export type CountdownSnapshot = {
    now: Date;
    parts: CountdownParts;
    totalMinutes: number;
    totalHours: number;
    totalDays: number;
    totalWeeks: number;
    workdays: number;
};

export type CountdownModeId = 'standard' | 'workdays' | 'totals' | 'snacks';

export type CountdownTile = {
    key: string;
    value: number;
    label: string;
};

export type CountdownMode = {
    id: CountdownModeId;
    label: string;
    getTiles: (snapshot: CountdownSnapshot) => CountdownTile[];
};

export const TARGET_DATE_PRESETS = [
    { id: 'jul1_2026', label: '1. července 2026', raw: '2026-07-01' },
    { id: 'jun28_2026', label: '28. června 2026', raw: '2026-06-28' },
] as const;

export type TargetDatePresetId = (typeof TARGET_DATE_PRESETS)[number]['id'];
